import Navbar from "./navbar"

const LiveMap = () => {
    return (
        <div>
      <Navbar />
      <div>This is Home Page</div>

      {/* Creating 5 buttons */}
      <button>HMC</button>
      <button>POMONA</button>
      <button>CMC</button>
      <button>PITZER</button>
      <button>SCRIPPS</button>
    </div>
    )
}

export default LiveMap